<h6>{{contentData.step}} 2</h6>
<p><b>{{contentData.manageAllocations}}</b></p>
<header class="table-flex table-header">
    <p><b>{{contentData.beneficiary}}</b></p>
    <p><b>{{contentData.payment}}</b></p>
</header>
<form [formGroup]="beneficiaryData">
    <div formArrayName="beneficiary">
        <section class="table-content" *ngFor="let bene of Beneficiary.controls;let i=index;" [formGroupName]="i">

            <article class="table-flex">
                <p class="name-content"> {{contentData.beneficiary}} {{i+1}}<span
                        *ngIf="bene.get('forename')?.value || bene.get('surname')?.value">:
                        {{bene.get('forename')?.value}} {{bene.get('surname')?.value}}</span></p>
                <div class="col-md-3 text-box-position percentage-content">
                    <div class="input-group">
                        <input type="text" class="form-control col-md-4" formControlName="beneficiaryAllocPercentage" currency
                            [DecimalPlaces]="2" [minValue]="0.01" [maxValue]="100"  inputmode="numeric"
                            [ngClass]="{'error-textbox':((bene.get('beneficiaryAllocPercentage')?.value == 0 && bene.get('beneficiaryAllocPercentage')?.value !='') ||  ((bene.get('beneficiaryAllocPercentage')?.dirty || bene.get('beneficiaryAllocPercentage')?.touched) && bene.get('beneficiaryAllocPercentage')?.errors?.required) )}">

                        <div class="input-group-append">
                            <span class="input-group-text">%</span>
                        </div>
                    </div>


                </div>
            </article>

            <article class="error-flex">
                <p *ngIf="((bene.get('beneficiaryAllocPercentage')?.dirty || bene.get('beneficiaryAllocPercentage')?.touched)  && bene.get('beneficiaryAllocPercentage')?.value =='')"
                    class="remove">{{contentData.errorMessageText}} {{i+1}} </p>
                <p *ngIf="(bene.get('beneficiaryAllocPercentage')?.value == 0 && bene.get('beneficiaryAllocPercentage')?.value !='') " class="remove">
                    {{contentData.errorMessageText}} {{i+1}} </p>
            </article>
        </section>


        <footer class="table-flex table-footer">
            <p><b>Total</b></p>

            <p [ngClass]="{'remove' : (getTotal() > 0 && getTotal() < 100) || (getTotal() > 0 && getTotal() > 100) }">
                <b>{{getTotal() | number:'1.2-2' }}% </b>
            </p>
        </footer>
        <p *ngIf="(getTotal() > 0 && getTotal() < 100) || (getTotal() > 0 && getTotal() > 100)"
            class="remove text-center">{{contentData.totalAllocation}}</p>
    </div>
</form>